import { render, staticRenderFns } from "./satisfactions.vue?vue&type=template&id=163a8ae7&scoped=true&"
import script from "./satisfactions.vue?vue&type=script&lang=js&"
export * from "./satisfactions.vue?vue&type=script&lang=js&"
import style0 from "./satisfactions.vue?vue&type=style&index=0&id=163a8ae7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163a8ae7",
  null
  
)

export default component.exports